<template>
  <dx-data-grid
      :ref="gridRefName"
      :data-source="datasource"
      :summary="summary"
      :columns="columns"
      :show-borders="false"
      :show-column-lines="false"
      :column-auto-width="true"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :hover-state-enabled="!gridTouch"
      :show-row-lines="true"
      :height="embedded ? '100%' : undefined"
      :error-row-enabled="!embedded"
      :scrolling="scrolling"
    >
      <dx-filter-row :visible="!embedded" />
      <dx-load-panel :enabled="!embedded" />
      <dx-paging :page-size="defaultPageSize" />
      <dx-pager
        :visible="!embedded"
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :info-text="'Seite {0} von {1} ({2} Verkäufe)'"
      />
      <dx-export
        :enabled="false"
        :allow-export-selected-data="false"
        file-name="CitybusFlexibusVerkäufe"
        :texts="{
          exportAll: 'Alles herunterladen',
          exportSelectedRows: 'Auswahl herunterladen',
          exportTo: 'Excel Download',
        }"
      />
  </dx-data-grid>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxExport,
  DxFilterRow,
  DxLoadPanel,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import DataGridMixin from "@/mixins/DataGridMixin";
import moment from "moment";
const cjson = require("compressed-json");

export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxPager,
    DxExport,
    DxFilterRow,
    DxLoadPanel,
  },
  mixins: [DataGridMixin],
  props: {
    month: { type: String, default: undefined },
    fromMonth: { type: String, default: undefined },
    // eingebettet in die Seite Exporte: ohne Filterzeile, Pager, Ladeanzeige und Fehlerzeile, volle Höhe
    embedded: { type: Boolean, default: false },
  },
  computed: {
    // ein Schlüssel für beide Monate: ändert die Seite von und bis zugleich, wird genau einmal geladen
    periodKey() {
      return `${this.fromMonth}|${this.month}`;
    },
  },
  watch: {
    periodKey: function () {
      this.refreshDataGrid();
    },
  },
  data() {
    return {
      gridRefName: "citybusFlexibusDataGrid",
      datasource: new CustomStore({
        load: () => {
          var dateStart = moment(`${this.fromMonth}-01`);
          var dateEnd = moment(`${this.month}-01`);
          var timeValues = [];
          while (dateEnd > dateStart || dateStart.format("M") === dateEnd.format("M")) {
            timeValues.push({
              month: dateStart.format("MM"),
              year: dateStart.format("YYYY"),
            });
            dateStart.add(1, "month");
          }
          return new Promise((resolve) => {
            axios
              .all(
                timeValues.map((month) =>
                  axios.get(
                    `${this.$store.state.baseUrl}ticketsale?sale_month=${month.month}&sale_year=${month.year}&option=compress`
                  )
                )
              )
              .then((responseArr) => {
                let response = [];
                for (var i = 0; i < responseArr.length; i++) {
                  response = response.concat(cjson.decompress(responseArr[i].data));
                }
                resolve(response);
              });
          });
        },
      }),

      columns: [
        {
          dataField: "line_id",
          caption: "Linie",
          alignment: "left",
        },
        {
          dataField: "ticket_type_id",
          caption: "Ticketcode",
          alignment: "left",
        },
        {
          caption: "Tickettyp",
          alignment: "left",
          calculateDisplayValue: function () {
            return "Einzelfahrt";
          },
        },
        {
          dataField: "username",
          caption: "Fahrername",
          alignment: "left",
        },
        {
          dataField: "sale_date",
          caption: "Verkaufsdatum",
          sortOrder: "desc",
          dataType: "date",
          calculateDisplayValue: function (rowData) {
            if (!rowData.sale_time) return null;
            return moment(rowData.sale_time).format("DD.MM.YYYY");
          },
          calculateSortValue: function (rowData) {
            return moment(rowData.sale_time).valueOf();
          },
        },
        {
          dataField: "sale_time_time",
          caption: "Verkaufszeit",
          sortOrder: "desc",
          calculateDisplayValue: function (rowData) {
            if (!rowData.sale_time) return null;
            return moment(rowData.sale_time).format("HH:mm:ss");
          },
        },
        {
          dataField: "ticket_name",
          caption: "Ticketbezeichnung",
          alignment: "left",
        },
        {
          dataField: "tariff_name",
          caption: "Tarifname",
          alignment: "left",
        },
        {
          dataField: "ticket_count",
          caption: "Anzahl Personen",
          alignment: "left",
          dataType: "number",
          cssClass: "app-zahl",
        },
        {
          dataField: "price",
          caption: "Preis",
          alignment: "right",
          dataType: "number",
          format: "######0.00",
        },
        {
          caption: "Währung",
          alignment: "left",
          calculateCellValue: function () {
            return "EUR";
          },
        },
        {
          caption: "Monat",
          sortOrder: "desc",
          calculateDisplayValue: function (rowData) {
            if (!rowData.sale_time) return null;
            return moment(rowData.sale_time).format("M");
          },
        },
      ],
    };
  },
  methods: {
    refreshDataGrid() {
      const grid = this.$refs[this.gridRefName];
      if (grid && grid.instance) {
        grid.instance.refresh();
      }
    },
    // Exporte (Frage F3): das eigene Grid über das vorhandene dx-export als „CitybusFlexibusVerkäufe.xlsx“
    exportToExcel() {
      this.$refs[this.gridRefName].instance.exportToExcel(false);
    },
  },
};
</script>
